var map = {
	"./andersen-logo.svg": 1528,
	"./checkmark.svg": 9812,
	"./email.svg": 1903,
	"./facebook.svg": 8195,
	"./instagram.svg": 751,
	"./letter-success.svg": 6916,
	"./location.svg": 2220,
	"./owl-soul-logo.svg": 6250,
	"./phone.svg": 4089,
	"./select-arrow.svg": 6371,
	"./slider-arrow.svg": 402,
	"./telegram.svg": 6435,
	"./twitter.svg": 357,
	"./warning.svg": 351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;